var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.current_tab ? 'tab-style-actual' : 'tab-style-deactivated',on:{"click":_vm.onClick}},[_vm._v(_vm._s(_vm.tab_name.toUpperCase()))])}
var staticRenderFns = []

export { render, staticRenderFns }